export const CHANGE_LOADING_STATUS = 'CHANGE_LOADING_STATUS';

export interface LoadingActionI {
  type: typeof CHANGE_LOADING_STATUS;
  payload: {
    value: boolean;
  };
}
export const setLoading = (value: boolean): LoadingActionI => ({
  type: CHANGE_LOADING_STATUS,
  payload: {
    value,
  },
});
